<div class="panel-sidebar-section-body">
    <div class="form-row">
        <div class="form-label form-label-thin pb-1">Security Type</div>
        <div class="custom-controls-stacked">
            <label class="custom-control custom-checkbox" *ngFor="let searchType of searchTypes">
                <input class="custom-control-input" type="checkbox"
                    [(ngModel)]="searchType.checked" (ngModelChange)="changeSearchType()">
                <span class="custom-control-indicator"></span><span class="custom-control-description">
                    {{ searchType.label }}
                </span>
            </label>
        </div>
    </div>
</div>
